import React, { useEffect, useState } from "react";
import { Heading } from "../../../design/heading";
import SelectParticipantField from "../../../components/Fields/SelectParticipantField";
import SelectParticipantsField from "../../../components/Fields/SelectParticipantsField";
import { Participant } from "../../../models/Participant";
import { Button } from "../../../design/button";
import { useMatter } from "../../../contexts/MatterContext";
import { Divider } from "../../../design/divider";

const MatterParties: React.FC = () => {
  const { currentMatter, updateMatter } = useMatter();

  const [client, setClient] = useState<Participant["_id"] | undefined>(
    currentMatter?.meId,
  );
  const [otherParty, setOtherParty] = useState<Participant["_id"] | undefined>(
    currentMatter?.opponentId,
  );
  const [kids, setKids] = useState<Participant["_id"][]>(
    currentMatter?.kidIds ?? [],
  );

  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setClient(currentMatter?.meId);
    setOtherParty(currentMatter?.opponentId);
    setKids(currentMatter?.kidIds ?? []);
  }, [currentMatter]);

  const handleSave = async () => {
    if (!currentMatter || !client || !otherParty) return;

    setIsSaving(true);
    try {
      await updateMatter(currentMatter._id, {
        meId: client,
        opponentId: otherParty,
        kidIds: kids,
      });
    } catch (error) {
      console.error("Error updating parties:", error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between gap-4">
        <Heading>Parties Involved</Heading>
        <Button
          onClick={handleSave}
          disabled={
            isSaving ||
            (client === currentMatter?.me?._id &&
              otherParty === currentMatter?.opponent?._id &&
              JSON.stringify(kids) ===
                JSON.stringify(currentMatter?.kids?.map((k) => k._id)))
          }
        >
          {isSaving ? "Saving..." : "Save"}
        </Button>
      </div>

      <Divider />

      <div className="space-y-4">
        <SelectParticipantField
          label="Client"
          value={client}
          onChange={setClient}
        />

        <SelectParticipantField
          label="Other Party"
          value={otherParty}
          onChange={setOtherParty}
        />

        <SelectParticipantsField
          label="Kids"
          onChange={setKids}
          values={kids}
        />
      </div>
    </div>
  );
};

export default MatterParties;
